<script setup>
defineProps({
  label: {
    type: String,
    default: __('new')
  },
  forceText: {
    type: Boolean,
    default: false
  }
})
</script>

<template>
  <div class="bg-gradient-to-br from-blue-500 via-purple-500 to-pink-500 text-white rounded-xl border border-white text-xxs font-semibold text-center">
    <template v-if="forceText">
      <p class="px-1.5 py-0.5">{{ label }}</p>
    </template>
    <template v-else>
      <p class="hidden md:block px-1.5 py-0.5">{{ label }}</p>
      <p class="md:hidden size-4 font-bold">!</p>
    </template>
  </div>
</template>
